import { getZombieInstanceFromPrimaryKey, isValidBusinessObject } from '@iotv/iotv-v3-types';
import { aggregateGeofenceMetrics } from '../fns';
import { geoObjectCodec } from '../../../GoogleMapV4';
import { existsFilter } from '@iotv/core-services';
const { REACT_APP_PROJECT_STAGE } = process.env;
const debug = process.env.REACT_APP_DEBUG && false;
export const getReceptionStats = ({ coverageReport, Networks, Gateways }) => {
    const filteredByNetworkGatewayMetrics = Object.entries(coverageReport.Networks)
        .filter(([nwID, networkMetrics]) => (Networks.length === 0 || Networks.includes(nwID) || (REACT_APP_PROJECT_STAGE !== 'prod' && nwID === 'Interceptor')) && networkMetrics)
        .map(([nwID, networkMetrics]) => networkMetrics.GatewayStats);
    const allStats = Object.values(filteredByNetworkGatewayMetrics)
        .map((gatewaysStats) => {
        const perNework_GWStats = Object.entries(gatewaysStats)
            .filter(([gatewayEui, stats]) => Gateways.length === 0 || Gateways.find((gw) => gw.eui === gatewayEui))
            .map(([gatewayEui, stats]) => stats);
        return perNework_GWStats;
    })
        .flat();
    const receptionStats = aggregateGeofenceMetrics(allStats);
    debug &&
        console.log(`getReceptionStats returning results from  `, { coverageReport, allStats, filteredByNetworkGatewayMetrics, Networks, Gateways, receptionStats });
    return receptionStats;
};
export const coverageReportToGeoObject = ({ cr, Gateways, Networks, }) => {
    const newId = `Area:_${cr.GeoObject.id}_${cr.created}`;
    const identity = getZombieInstanceFromPrimaryKey(newId, { metadata: { generatedFrom: cr.GeoObject.sk } });
    const pseudoVob = {
        ...cr.GeoObject,
        name: `Coverage ${cr.GeoObject.name}`,
        points: cr.receptionGeofence.points, // reception geofence will be the area surrounding a point (if a place), or the area itself (if an area)
        id: `_${cr.GeoObject.id}`,
        sk: `Coverage:_${cr.GeoObject.id}`,
        receptionStats: getReceptionStats({ coverageReport: cr, Networks, Gateways }),
    };
    Object.assign(pseudoVob, identity);
    return pseudoVob;
};
/** Gateway to reception point paths
 * Every gateway stat is flat mapped out of the report and resolved against the gateway object
 * The gateway and geoObject are the source and target of the line repsectively.
 * Where either end has a geofence, the line is trucated at the perimeter
 * Stats are passed  in to the line Feature properties
 * Display f
 *
 */
export const coverageReportToLineDefiningPairs = (coverageReport, networks) => {
    const pairs = Object.entries(coverageReport.Networks)
        .filter(([nwId, nwMetrics]) => !!nwMetrics)
        .map(([nwId, nwMetrics]) => {
        const { GeoObject } = coverageReport;
        const targetNode = geoObjectCodec.toGeoObject(GeoObject);
        /** if the targetNode is a point it will have no Geofence.points, but the coverage report will have  */
        if (!targetNode?.points && coverageReport.receptionGeofence.points) {
            targetNode.points = coverageReport.receptionGeofence.points;
        }
        const { GatewayStats, Gateways, Network } = nwMetrics;
        if (targetNode?.points && networks.includes(Network)) {
            return Object.entries(GatewayStats)
                .map(([gwEui, gwMetrics]) => {
                let pair = undefined;
                const gateway = Gateways.find((gw) => gw.eui === gwEui);
                const sourceNode = gateway && geoObjectCodec.toGeoObject(gateway);
                if (sourceNode) {
                    pair = { sourceNode, targetNode, data: GatewayStats[gwEui] };
                }
                return pair;
            })
                .filter((p) => !!p);
        }
        else {
            return [];
        }
    })
        .flat();
    return pairs;
};
const coverageGeoObjectToValidGeoObject = (coverageObject) => {
    if (isValidBusinessObject(coverageObject)) {
        const { receptionStats, ...others } = coverageObject;
        const gob = geoObjectCodec.toGeoObject(others);
        if (gob) {
            debug && console.log(`coverageGeoObjectToValidGeoObject setting data`, { gob, receptionStats });
            gob.data = receptionStats;
        }
        debug && console.log(`coverageGeoObjectToValidGeoObject returning`, { gob, coverageObject });
        return gob;
    }
    else {
        return null;
    }
};
export const coverageGeoObjectsToValidGeoObjects = (coverageGeoObjects) => coverageGeoObjects.map(coverageGeoObjectToValidGeoObject).filter(existsFilter) ?? [];
